/*global DSV, jQuery */

/** 
 * DSV selfService
 */

(function ($, window) {
    "use strict";


    DSV.ui.serviceTabs = {

        DOM: {
            module: $('.service-tabs'),
            serviceSection: $('.module.service-tabs'),
            tabs: $('.service-tabs__tab'),
            tntSelect: $('.service-tabs__tnt-select'),
            tntSubmit: $('.service-tabs__tnt-submit'),
            tntForm: $('.service-tabs__tnt-form'),
            tntInput: $('.service-tabs__tnt-input')
        },

        updateFormUrl: function() {
            const newUrl = this.DOM.tntForm.prop("action").split("?")[0] +
            "?params=%257B%2522searchValue%2522%253A%2522" + this.DOM.tntInput.val().toUpperCase() +
            "%2522%257D" +
            "&state=search";

            this.DOM.tntForm.attr('action', newUrl);
        },

        init: function() {
            const that = this;
            let isMobileView = DSV.tools.screenMode.currentMode <= DSV.tools.screenSizes.desktop;

            this.DOM.tabs.click(function (e) {
                isMobileView = DSV.tools.screenMode.currentMode <= DSV.tools.screenSizes.desktop;
                let tabsOpen = 0;

                that.DOM.tabs.each((key, item) => {
                    const correspondingInfo = $(item).data('linkedInfo');

                    // If module hasn't been interacted with on desktop, we have a special case for tab one if that's the one that's clicked. 
                    // This is to make the module able to have the first tab closed on mobile without causing unwanted animation on load. 
                    // It may seem a little tricky / hacky but it's pretty simple in the end.
                    if (!isMobileView 
                        && that.DOM.module.hasClass('service-tabs--closed') 
                        && $(item).hasClass('service-tabs__tab--one') 
                        && $(e.target).hasClass('service-tabs__tab--one')) {
                            $(item).addClass('service-tabs__tab--selected');
                            $(`.${correspondingInfo}`).addClass('open');
                            tabsOpen ++;
                            return;
                    }
                    
                    // Handle opening and closing of tabs
                    if (this !== item || (isMobileView && $(`.${correspondingInfo}`).hasClass('open'))) {
                        $(item).removeClass('service-tabs__tab--selected');
                        TweenLite.to($(`.${correspondingInfo} a`), 0, { opacity: 0 });
                        TweenLite.to($(`.${correspondingInfo}`), 0.25, { opacity: 0 });
                        TweenLite.to($(`.${correspondingInfo}`), 0.5, { height: '0' });
                        TweenLite.to($(`.${correspondingInfo} a`), 0.5, { opacity: 1 }).delay(0.5);
                        $(`.${correspondingInfo}`).removeClass('open');
                    } else if (isMobileView || (!isMobileView && !$(`.${correspondingInfo}`).hasClass('open'))) {
                        TweenLite.to($(`.${correspondingInfo} a`), 0, { opacity: 1 });
                        TweenLite.set($(`.${correspondingInfo}`), { height: 'auto', opacity: 1 });
                        TweenLite.from($(`.${correspondingInfo}`), 0.5, { height: 0, opacity: 0 });
                        $(`.${correspondingInfo}`).addClass('open');
                        $(item).addClass('service-tabs__tab--selected');

                        tabsOpen++;
                    }
                });

                if (tabsOpen > 0) {
                    that.DOM.module.removeClass('service-tabs--closed')
                } else if (isMobileView) {
                    that.DOM.module.addClass('service-tabs--closed')
                }
            })

            // Handles Get a quote
            this.DOM.tntSubmit.click(function(e) {
                e.preventDefault();
                const selectedIndex = that.DOM.tntSelect[0].selectedIndex;
                const selectedValue = that.DOM.tntSelect[0].options[selectedIndex].value;
                let selectedTarget = that.DOM.tntSelect[0].options[selectedIndex].getAttribute("data-target");
                if (selectedValue === "") return;
                if (selectedTarget === "") selectedTarget = "_self";
                window.open(selectedValue, selectedTarget);
            })

            // Handles Track & Trace
            this.DOM.tntForm.submit(function(e) {
                e.preventDefault();
                let submitTarget = that.DOM.tntForm.attr("target");
                if (submitTarget === "") submitTarget = "_self";
                const NoRefErrorMsg = that.DOM.serviceSection.attr("data-no-reference-error");
                const WrongRefErrorMsg = that.DOM.serviceSection.attr("data-wrong-reference-error");
                if (that.DOM.tntInput.val().trim() === "") return window.alert(NoRefErrorMsg);
                if (!(/^[^,]{3,}([,][^,]{3,})*$/g.test(that.DOM.tntInput.val()))) return window.alert(WrongRefErrorMsg);
                window.open(that.DOM.tntForm.prop("action"), submitTarget);
            });

            this.DOM.tntInput.keypress(function(e) {
                that.updateFormUrl();
            });

            this.DOM.tntInput.change(function(e) {
                const newInput = $(this).val()
					.replace(/\s+/g, ",")
					.replace(/[,]{2,}/g, ",")
                    .replace(/^[,]+|[,]+$/g, "");
                    
                $(this).val(newInput);

                that.updateFormUrl();
            });
        }
    };

})(jQuery, window);